import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/gopal/Sushmita/aarohi/components/aarohi/ProductCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/gopal/Sushmita/aarohi/node_modules/next/dist/client/app-dir/link.js");
